import { render, staticRenderFns } from "./SectionPrivacy.vue?vue&type=template&id=6b7671bc&scoped=true"
import script from "./SectionPrivacy.vue?vue&type=script&lang=ts"
export * from "./SectionPrivacy.vue?vue&type=script&lang=ts"
import style0 from "./SectionPrivacy.vue?vue&type=style&index=0&id=6b7671bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7671bc",
  null
  
)

export default component.exports